import styled from "styled-components"
import Div from "../div/div.component"
import Grid from "../grid/grid.component"

export const FromTheFounderContainer = styled(Div)`
  background: #4c0ffb;
  padding: 120px 20px 80px 20px;
  @media only screen and (max-width: 760px) {
    padding: 60px 0 0 0;
  }
`
export const FromTheFounderGrid = styled(Grid)`
  margin: auto;
`

export const FTFLeftColumn = styled.div`
  grid-column: span 6;
  text-align: center;
  & a {
    margin: auto;
  }
  @media only screen and (max-width: 999px) {
    grid-column: span 3;
  }
  @media only screen and (max-width: 760px) {
    grid-column: span 6;
    margin-bottom: 60px;
    padding: 0 20px;
  }
`

export const FTFRightColumn = styled.div`
  grid-column: span 6;
  @media only screen and (max-width: 999px) {
    grid-column: span 3;
  }
  @media only screen and (max-width: 760px) {
    grid-column: span 6;
    padding: 0 20px;
  }
`

export const FounderImage = styled.img`
  border-radius: 50%;
  width: 300px;
  height: 300px;
  margin: auto;
  margin-bottom: 40px;
`

export const FounderMessageTitle = styled.h2`
  ${({ theme: { typography } }) => typography.desktop.h2};
  color: #fff;
  span {
    font-weight: 100;
  }
  @media only screen and (max-width: 760px) {
    ${({ theme: { typography } }) => typography.mobile.h2};
    color: #fff;
    span {
      font-weight: 100;
    }
  }
`

export const FounderMessage = styled.div`
  margin: 40px 0 80px 0;
  & p {
    ${({ theme: { typography } }) => typography.desktop.body};
    color: #fff;
    margin: 35px 0;
  }
  @media only screen and (max-width: 760px) {
    margin: 25px 0 60px 0;
    & p {
      ${({ theme: { typography } }) => typography.mobile.body};
    }
  }
`

export const FounderStraplineContainer = styled.div`
  grid-column: span 12;
  background: #fff;
  border-radius: 25px;
  padding: 80px 80px 60px 80px;
  & a {
    margin: auto;
    margin-top: 50px;
  }
  @media only screen and (max-width: 999px) {
    grid-column: span 6;
  }
  @media only screen and (max-width: 760px) {
    grid-column: span 6;
    width: 100%;
    border-radius: 25px 25px 0 0;
    padding: 60px 20px;
    & a {
      width: 100%;
      padding: 0;
    }
  }
`
